import React from 'react'
import { WhyUs } from '@/commons/service-hub/WhyUs'
import { domesticReasons, helperReasons } from 'data/service-hub-content'

// Domestic preset of the shared WhyUs section. `recurring` adds the claims that
// only apply to part-time (weekly/fortnightly) helpers: the same helper each
// visit and the Monday-Saturday schedule. The one-off deep cleaning pages
// (move-in/move-out, professional house cleaning) leave it off.
export const HelperWhyChooseUs = ({ recurring = false }) => (
    <WhyUs
        title={recurring ? 'Why Choose StringsSG Part Time Helpers?' : 'Why Choose StringsSG?'}
        reasons={recurring ? helperReasons : domesticReasons}
    />
)
